function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useState } from 'react';
import { apiKey } from '@rd-web-markets/shared/dist/util/tinyMceConfig';
import { Editor } from '@tinymce/tinymce-react';
import { onCut, onKeyDown, onSelectionChange } from './modules/track_changes/tinyMceEditorHighlightingUtils';
import CommentsView from './modules/comments/CommentsView';

/**
 * Not all tinymce events are supported by tinymce-react.
 * An up to date list of supported events can be seen here: https://github.com/tinymce/tinymce-react/blob/main/src/main/ts/Events.ts
 * Note that we are using tinymce V5.
 * 
 * The up to da
 * @param {*} param0 
 * @returns 
 */

export default function EditorWithChangeHighlights(_ref) {
  let {
    editorContent,
    editorWithHighlightsConfig,
    onEditorChange,
    modelClass,
    modelId,
    modelField,
    focusOnInit = true,
    onCreateComment,
    showTrackChangesControls = false,
    ...props
  } = _ref;
  const [clipboardData, setClipboardData] = useState(null);
  const [activeEditorInstance, setActiveEditorInstance] = useState(null); // needed for comments

  const tinyMceContainerCss = `
    .tox-tinymce {
      flex-grow: 1;
      height: 500px;
    }

    .disabled-btn {
      position: relative !important;
    }

    .disabled-btn:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-image: linear-gradient(120deg, #eaee44, #33d0ff);
      opacity: .7;
    }

    .TrackChanges-Highlight-Deletion {
      color: red !important;
      text-decoration: line-through !important;
      font-weight: bold !important;
      display: inline-block;
    }

    .TrackChanges-Highlight-Addition {
      color: green !important;
      font-weight: bold !important;
      display: inline-block;
    }
  `;
  return /*#__PURE__*/React.createElement("div", {
    className: "d-flex"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      alignItems: 'stretch',
      position: 'relative'
    }
  }, /*#__PURE__*/React.createElement("style", null, tinyMceContainerCss), /*#__PURE__*/React.createElement("div", {
    style: {
      flexGrow: 1,
      display: 'block'
    }
  }, /*#__PURE__*/React.createElement(Editor, _extends({
    apiKey: apiKey,
    value: editorContent,
    name: "body",
    onInit: event => {
      if (focusOnInit) {
        // We could also just call setActiveEditorInstance here, but for some reason
        // when we call activeEditorInstance.execCommand('mceCleanup') on that instance, it throws errors.
        // When we call activeEditorInstance.execCommand('mceCleanup') on the instance of the onFocus function, it works fine.
        event.target.getBody().focus();
      }
    },
    onFocus: data => {
      setActiveEditorInstance(data.target);
    },
    onCut: event => {
      onCut(event, activeEditorInstance);
    },
    onEditorChange: (currentValue, editor) => {
      // Must always pass the currentValue comming from the editor.
      // Even if you pass an equal string, that breaks the editiing. it must be the same string instance.
      onEditorChange(currentValue, editor);
    },
    onSelectionChange: (event, editor) => {
      onSelectionChange(event, editor);
    },
    onKeyDown: (event, editor) => {
      try {
        onKeyDown(event, editor, clipboardData, setClipboardData);
      } catch (e) {
        // TypeError
        // Quite possible that we are deleting at the start or at the end of the body and it doesn't make sense to be able to
        console.error(e);
      }
    },
    init: editorWithHighlightsConfig(() => {})
  }, props)))), /*#__PURE__*/React.createElement("div", {
    className: "d-flex"
  }, /*#__PURE__*/React.createElement(CommentsView, {
    editor: activeEditorInstance,
    modelClass: modelClass,
    modelId: modelId,
    modelField: modelField
  })));
}